import root from 'window-or-global';


export const API_BASE_URL = 'www.quikr.com/jobs';

export const ALL_CITIES_API = '/jobsAjax/getAllCities';

export const ALL_ROLES_API = '/jobsAjax/roleSearch?all=1';

export const LOCALITY_SEARCH_API = 'jobsAjax/localitySearch?cityName=';

export const APPLY_SUBMIT_API = '';

export const SIMILAR_JOBS_API = '';

export const CONTEXT_API = '/jobsAjax/context';

export const UNLIMITED_FREE_ADS_PAYMENT_API = '/unlimited-free-ads-payment';

export const ROLE_FACET_COUNT_API = '/role-facet-count';

export const RELATED_CATEGORIES_API = '/relatedCategories';

export const API_PROTOCOL = root.location && root.location.protocol + '//';

export const WHATSAPP_TEXT_API = 'https://wa.me/918066095795?text=';



// WEBPACK FOOTER //
// ../q-jobs/src/constants/apiEndpoints.js